import React from 'react';
export function BenefitsSection() {
  const benefits = ['Más claridad mental', 'Menos ansiedad', 'Más confianza', 'Menos autosabotaje', 'Mejor toma de decisiones', 'Más enfoque', 'Más energía', 'Más dirección', 'Más abundancia', 'Más paz interior'];
  return <section className="px-4 py-7 sm:py-9 bg-dark-card/30 border-t border-brand-gold/10" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-5 sm:mb-6" data-id="element-16">
          Lo que vas a empezar a <span className="text-brand-gold" data-id="element-17">notar</span>
        </h2>

        <div className="grid grid-cols-2 gap-2" data-id="element-18">
          {benefits.map((benefit, i) => <div key={i} className="bg-dark-card border border-brand-gold/20 rounded-md px-3 py-2 flex items-center gap-2 hover:border-brand-gold/50 transition-colors" data-id="element-19">
              <span className="text-brand-gold text-sm flex-shrink-0" data-id="element-20">✓</span>
              <span className="text-xs sm:text-sm" data-id="element-21">{benefit}</span>
            </div>)}
        </div>
      </div>
    </section>;
}